import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import cx from 'classnames'

import styles from "./business-card-header.module.scss";

const BusinessCardHeader = (props) => {
  return (
    <div className={styles.business_card__header}>
      <div className={styles.presentation}>
        <div className={styles.presentation__content}>
          <img className={styles.user_img} src={props.data.img} alt={props.data.name} />
          <h1 className={styles.name}>{props.data.name}</h1>
          <h2 className={styles.title}>{props.data.role}</h2>
        </div>
        <div className={styles.presentation__action_panel}>
          <button className={cx(styles.btn, styles.btn_phone)}>
            <a href={'tel:' + props.data.phone} className={styles.link}>
              <FontAwesomeIcon icon={solid("phone")} size="2x" />
              <span>Call</span>
            </a>
          </button>
          <button className={cx(styles.btn, styles.btn_mail)}>
            <a href={'mailto:' + props.data.email} className={styles.link}>
              <FontAwesomeIcon icon={solid("envelope")} size="2x" />
              <span>Email</span>
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BusinessCardHeader;
